const ded = `<h1>Política de Uso Aceptable</h1>
<h2>DressDown.me</h2>
<p><strong>Fecha de entrada en vigor:</strong> 01.05.2025</p>
<h2>Disposiciones Generales</h2>
<p>Esta Política de Uso Aceptable (“Política”) define los usos permitidos y prohibidos del sitio web <a href="https://dressdown.me">https://dressdown.me</a> (“Sitio”). Al utilizar el Sitio, usted acepta cumplir con esta Política, así como con otros términos y políticas aplicables, incluyendo la Política de Privacidad y los Términos de Uso.</p>
<h2>Uso Permitido</h2>
<p>Los usuarios se comprometen a:</p>
<ul>
  <li>Usar el Sitio exclusivamente con fines legales y de conformidad con las leyes aplicables de la Unión Europea y otras jurisdicciones.</li>
  <li>Respetar los derechos de otros usuarios y de terceros, incluidos los derechos de privacidad, propiedad intelectual e integridad personal.</li>
  <li>Proporcionar información veraz al registrarse y utilizar el Sitio.</li>
</ul>
<h2>Uso Prohibido</h2>
<p>Está prohibido utilizar el Sitio para:</p>
<ul>
  <li>Violar la ley: subir, publicar o distribuir contenido que infrinja leyes o normativas locales, nacionales o internacionales.</li>
  <li>Dañar a menores: publicar, distribuir o acceder a materiales que incluyan imágenes o descripciones de menores en contextos sexuales, o cualquier acción que pueda perjudicar a menores.</li>
  <li>Distribuir malware: transmitir virus, troyanos, gusanos, registradores de teclas, software espía u otros códigos maliciosos.</li>
  <li>Violar derechos de propiedad intelectual: publicar contenido que infrinja derechos de autor, marcas registradas, patentes u otros derechos de propiedad intelectual de terceros.</li>
  <li>Fomentar odio o discriminación: publicar contenido que contenga difamación, insultos, amenazas o discriminación por motivos de raza, género, religión, nacionalidad, discapacidad, orientación sexual o edad.</li>
  <li>Participar en fraudes o engaños: participar en estafas, phishing, difusión de información falsa o engañar a otros usuarios.</li>
  <li>Comprometer la seguridad: intentar acceder sin autorización a sistemas, datos o cuentas de otros usuarios, o interferir en el funcionamiento del Sitio o su infraestructura.</li>
</ul>
<h2>Estándares de Contenido</h2>
<p>Los usuarios se comprometen a no publicar contenido que:</p>
<ul>
  <li>Sea ilegal, dañino, ofensivo, obsceno o contrario a la moral pública.</li>
  <li>Contenga información falsa o engañosa.</li>
  <li>Infrinja derechos de terceros, incluidos derechos de autor, marcas registradas o derechos de privacidad.</li>
  <li>Promueva la violencia, el odio, la discriminación o actividades ilegales.</li>
  <li>Contenga material sexual que represente o describa a menores de edad.</li>
</ul>
<h2>Restricciones de Edad</h2>
<p>El Sitio está destinado exclusivamente a personas mayores de 18 años. Aplicamos medidas de verificación de edad, incluyendo servicios de terceros como Seon y tecnologías de análisis de imágenes como DeepFace, para impedir el acceso de menores a contenido para adultos.</p>
<h2>Infracciones y Consecuencias</h2>
<p>En caso de infringir esta Política, nos reservamos el derecho a:</p>
<ul>
  <li>Eliminar o bloquear el acceso al contenido que infrinja la normativa.</li>
  <li>Suspender o cancelar el acceso del usuario al Sitio sin previo aviso.</li>
  <li>Informar sobre la infracción a las autoridades competentes si así lo exige la ley.</li>
  <li>Tomar otras medidas necesarias para proteger el Sitio, a sus usuarios y para cumplir con la legislación.</li>
</ul>
<h2>Cambios en la Política</h2>
<p>Podemos actualizar esta Política periódicamente. Todos los cambios entrarán en vigor en el momento en que se publiquen en el Sitio. Recomendamos revisar la Política con regularidad para estar al tanto de las condiciones vigentes.</p>
<h2>Información de Contacto</h2>
<p>Si tiene preguntas o comentarios sobre esta Política, contáctenos:<br>
Correo electrónico: <a href="mailto:support@dressdown.me">support@dressdown.me</a></p>
`;

export default ded
